import { auth } from '@/shared/auth/storage';

// WebApi суурь хаяг. Default нь dev (vite) орчны localhost; production-д
// host-ийн /config endpoint-оос runtime-д уншиж дарж бичнэ (main.tsx bootstrap).
// Build-time override хэрэгтэй бол VITE_API_BASE env.
let apiBase =
  (import.meta.env.VITE_API_BASE as string | undefined) ?? 'https://localhost:44319';

export function setApiBase(url: string) {
  if (url) apiBase = url.replace(/\/+$/, '');
}

export function getApiBase() {
  return apiBase;
}

/* Host-ийн /config-оос apiBaseUrl уншина (carwashfront Program.cs serve хийдэг).
   Vite dev server-т /config байхгүй — default localhost хэвээр үлдэнэ. */
export async function loadRuntimeConfig(): Promise<void> {
  try {
    const res = await fetch('/config', { headers: { Accept: 'application/json' } });
    if (!res.ok) return;
    const cfg = (await res.json()) as { apiBaseUrl?: string };
    if (cfg?.apiBaseUrl) setApiBase(cfg.apiBaseUrl);
  } catch {
    /* dev орчин эсвэл config унших боломжгүй — default-аар үргэлжилнэ */
  }
}

let activeScope: { tenantId: string; companyId: string } | null = null;
export function setApiActiveScope(s: { tenantId: string; companyId: string } | null) {
  activeScope = s;
}

let onUnauthorized: (() => void) | null = null;
export function setOnUnauthorized(cb: () => void) {
  onUnauthorized = cb;
}

export class ApiError extends Error {
  status: number;
  body: unknown;
  constructor(status: number, message: string, body: unknown) {
    super(message);
    this.status = status;
    this.body = body;
  }
}

interface CallOptions {
  anonymous?: boolean;
}

async function call<T>(method: string, path: string, body?: unknown, opts?: CallOptions): Promise<T> {
  const headers: Record<string, string> = { Accept: 'application/json' };
  if (!opts?.anonymous && auth.token) headers.Authorization = `Bearer ${auth.token}`;
  const scope = activeScope ?? cacheScope();
  if (scope) {
    headers['X-Ts-Tenant'] = scope.tenantId;
    headers['X-Ts-Company'] = scope.companyId;
  }
  if (body !== undefined) headers['Content-Type'] = 'application/json';

  const res = await fetch(`${apiBase}${path}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  if (res.status === 401) {
    auth.clear();
    onUnauthorized?.();
    throw new ApiError(401, 'Нэвтрэх эрх дууссан.', null);
  }
  if (!res.ok) {
    const parsed = await safeJson(res);
    const msg =
      (parsed && (parsed.detail || parsed.error || parsed.message)) || `Алдаа гарлаа (${res.status}).`;
    throw new ApiError(res.status, msg, parsed);
  }
  if (res.status === 204) return undefined as T;
  return (await safeJson(res)) as T;
}

function cacheScope() {
  const c = auth.getScopeCache();
  return c.tenantId && c.companyId ? { tenantId: c.tenantId, companyId: c.companyId } : null;
}

async function safeJson(res: Response): Promise<any> {
  const text = await res.text();
  if (!text) return null;
  try {
    return JSON.parse(text);
  } catch {
    return { message: text };
  }
}

export const api = {
  get: <T>(path: string, opts?: CallOptions) => call<T>('GET', path, undefined, opts),
  post: <T>(path: string, body?: unknown, opts?: CallOptions) => call<T>('POST', path, body, opts),
  put: <T>(path: string, body?: unknown, opts?: CallOptions) => call<T>('PUT', path, body, opts),
  del: <T>(path: string, opts?: CallOptions) => call<T>('DELETE', path, undefined, opts),
};
